var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ez-button',{attrs:{"type":_vm.type,"disabled":_vm.disabled,"data-cy":_vm.commonCy.SINGLE_ORDER.MANAGE_ORDER.BUTTON__RESOLVE},on:{"click":function($event){return _vm.$emit('actionClicked')}}},[_vm._v(" Resolve ")])
}
var staticRenderFns = []

export { render, staticRenderFns }